import { EntitysSelectors } from "@shared/src/enums/EntitysSelectors";
import { EntitySelectorDto } from "../EntitySelectorDto";

export class PanelEntitySelectorDto extends EntitySelectorDto {

	public static new(activeFilterKeys: Array<String>): PanelEntitySelectorDto{
        let result: PanelEntitySelectorDto = new PanelEntitySelectorDto();
		result.loadData(EntitysSelectors.Panel, "", activeFilterKeys, 0, false);
        return result;
    }

	public getUrlGoToMaintenance(): string {
		return "system/screensandforms/panelsetting";
	}

	public getUrlBack(): string {
		return "/maintenance/panel";
	}
  
}